export { default as getPageEyebrow } from './getPageEyebrow';
